/**
 * Oracle stores deduction amounts in NUMBER(8,2) columns: each deduction row
 * (ASK.FRADRATTUR.MAGN) and the aggregated weight deduction (ASK.VIGTANIR.FRADRATTUR).
 * The largest value that fits is 999999.99 — anything larger overflows the column and
 * makes the VIGTANIR trigger throw ORA-06502 ("numeric or value error: number precision
 * too large"). Keep this in sync with AppConstants.MAX_DEDUCTION_MAGN in LondunarkerfiAPI.
 */
export const MAX_FRADRATTUR_MAGN = 999999.99;

/** User facing message shown when a deduction amount would exceed the Oracle limit. */
export const MAX_FRADRATTUR_MAGN_MESSAGE = 'Frádráttur má ekki vera hærri en 999.999,99 kg.';

/**
 * Calculates the deduction amount (magn) the same way Oracle does: round(fjoldi * thyngd, 2).
 * @param fjoldi - the number of units (Fjöldi).
 * @param thyngd - the weight per unit (Þyngd).
 */
export const calculateFradratturMagn = (fjoldi: number, thyngd: number): number =>
  Math.round((fjoldi || 0) * (thyngd || 0) * 100) / 100;
